import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  Modal,
  message,
  Flex,
  Radio,
  Divider,
  Typography,
  Image,
} from 'antd';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import iconClose from 'utils/icon/icon_close_circle.svg';
import { handleMessage } from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import InputStyled from 'components/InputStyled';
import { charactersApis } from 'apis/characters/charactersApis';
import { PlayCricle } from 'iconsax-react';
import { LIVE2D_VIEWER_URL } from '../../../apis/config';
// import Typography from 'antd/lib/typography';
const { Text, Title } = Typography;

/**
 * * 등장인물 등록 모달
 */

interface IProps {
  visible: {
    createCharacter: boolean;
    createAbility: boolean;
    editAiblity: boolean;
    delete: boolean;
    name: string;
  };
  setVisible: (e: any) => void;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
  projectId: string | undefined;
  data: any;
}

const CharactersCreateProfile = ({
  visible,
  setVisible,
  setRefresh,
  refresh,
  projectId,
}: IProps) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [profileDetails, setProfileDetails] = useState<any>([]);
  const [selectedCharacterId, setSelectedCharacterId] = useState<string | null>(
    null,
  );

  const handleFetchData = async () => {
    const res = await charactersApis.charactersDetailList();
    setProfileDetails(res.list);
  };

  useEffect(() => {
    // noinspection JSIgnoredPromiseFromCall
    handleFetchData();
  }, []);

  const handleSubmit = async () => {
    if (inputValue === '') {
      handleMessage(message, 'warning', '캐릭터 이름을 입력해주세요');
      return;
    }

    if (!selectedCharacterId) {
      handleMessage(message, 'warning', '캐릭터를 선택해주세요');
      return;
    }

    if (projectId) {
      try {
        const postData = {
          speaker: inputValue,
        };
        setLoading(true);
        await charactersApis.charactersCopy(
          projectId,
          selectedCharacterId,
          postData,
        );
        setRefresh(!refresh);
        setLoading(false);
        handleClose();
      } catch (err) {
        setLoading(false);
        handleMessage(message, 'error', 'Upload failed');
      }
    }
  };

  /// 모달 닫기
  const handleClose = () => {
    setVisible({ ...visible, createCharacter: false });
    setInputValue('');
    // 폼을 비워줘야 이미지 첨부한 것도 비워진다.
  };

  const handleInputChange = (value) => {
    setInputValue(value);
  };

  const handleCheckboxChange = (characterId) => {
    setSelectedCharacterId(characterId);
  };

  return (
    <CustomModal
      title={t(
        'storyEpisodeID.storyTabMenuList.charactersContent.modal.createCharacter.title',
      )}
      visible={visible.createCharacter}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t(
              'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.miniCutContent.minicutRegisterModal.register',
            )}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
            disabled={loading}
          />
        </ButtonWrapper>
      }
      closeIcon={
        <img src={iconClose} width={20} height={20} alt='icon-close' />
      }
    >
      <SectionWarpper>
        <div>
          <p className='title'>
            {t(
              'storyEpisodeID.storyTabMenuList.charactersContent.modal.createCharacter.name',
            )}
          </p>
          <InputStyled
            value={inputValue}
            onChange={(e) => {
              handleInputChange(e.target.value);
            }}
            maxLength={30}
          />
          <p className='length-subtext'>
            {`${inputValue.length}/30 characters`}
          </p>
          {profileDetails.map((record: any) => (
            <React.Fragment key={record.id}>
              <Flex
                align='center'
                style={{ padding: '4px', backgroundColor: '#f7f7f7' }}
              >
                <Flex flex={1} justify='flex-start'>
                  <Checkbox
                    style={{ paddingRight: '16px' }}
                    checked={selectedCharacterId === record.id}
                    onChange={() => handleCheckboxChange(record.id)}
                  />
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      const motionView = `${LIVE2D_VIEWER_URL}?modelid=${record.model.model_id}&modelinfo=${record.model.slaves[0].file_key}`;
                      window.open(motionView, '_blank'); //motionview 새탭열기
                    }}
                  >
                    <Text
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        marginRight: '8px',
                      }}
                    >
                      {record.speaker}
                    </Text>
                    <PlayCricle size='24' />
                  </div>
                </Flex>
                <Flex justify='center'>
                  <Image
                    src={record.abilities[0]?.icon_url}
                    style={{
                      width: '70px',
                      height: '70px',
                      margin: 'auto',
                    }}
                  />
                </Flex>
              </Flex>
              <CustomDivider type={'horizontal'} />
            </React.Fragment>
          ))}
        </div>
      </SectionWarpper>
    </CustomModal>
  );
};

export default CharactersCreateProfile;

const CustomDivider = styled(Divider)`
  margin: 4px 0;
`;
const CustomModal = styled(Modal)`
  .ant-modal-body {
    padding: 0;
  }

  .ant-modal-content {
    box-shadow: none;
    width: 566px;
  }

  .ant-radio-wrapper {
    span {
      font-size: ${theme.fontSizes.normal};
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.2px;
      color: ${theme.colors.dark_500};
    }
  }

  .ant-modal-footer {
    margin-top: 10px !important;
  }

  ul {
    margin-left: 25px;
  }

  .ant-modal-close:hover {
    background-color: transparent;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const SectionWarpper = styled.div`
  & > * + * {
    margin-top: 8px;
  }

  .checkbox-section {
    display: flex;
    align-items: center;

    & > * + * {
      margin-left: 48px;
    }
  }

  .checkbox-item {
    display: flex;
    align-items: center;

    p {
      font-size: ${theme.fontSizes.sm};
      font-weight: ${theme.fontWeights.normal};
      line-height: 20px;
      letter-spacing: 0.2px;
      color: #000000;
    }

    & > * + * {
      margin-left: 8px;
    }
  }
`;
